import axios from 'axios';
import { get } from 'lodash-es';
import { from } from 'rxjs';
import { PAGE_SIZE_5, FIRST_PAGE } from '../../services/pagination-service';

export const getUserSettings = () => {
  const request = axios.get('/user/setting').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const saveUserSetting = (setting) => {
  const put = axios.put('/user/setting/save', setting);

  const data$ = from(put);
  return data$;
};

export const saveUserSettingPromise = (setting) => {
  return axios.put('/user/setting/save', setting);
};

export const getSellerUsers = () => {
  return axios.get('/user');
};

export const getCurrentUser = () => {
  const request = axios.get('/user/current');

  const data$ = from(request);
  return data$;
};

export const saveNewUser = (user) => {
  return axios.post('/user', user);
};

export const updateUser = (userId, updateBody) => {
  if (!userId) {
    return Promise.reject(new Error('no userId provided'));
  }
  return axios.put(`/user/${userId}`, updateBody);
};

export const getUserActivity = (userId, page = FIRST_PAGE, pageSize = PAGE_SIZE_5) => {
  return axios.get(`/user/${userId}/activity?page=${page}&pageSize=${pageSize}`);
};

export const unlockUser = (userId) => {
  return axios.post('/user/unlock', { userId });
};

export const generateWorkstationAuthToken = (username) => {
  return axios.post('/user/generateWorkstationAuthToken', { username });
};
export const validateWorkstationAuthToken = (username, token) => {
  return axios.post('/user/validateWorkstationAuthToken', { username, token });
};
